import React, { useState } from "react";
import { LiveTickets, TicketDetail } from "hubops-live-ticket-component";
import "hubops-live-ticket-component/dist/style.css";
const LiveTicketsPage = () => {
  const [selectedTicket, setSelectedTicket] = useState(null);

  return (
    <>
      <div style={{ padding: "20px" }}>
        <LiveTickets
          config={{
            env: process.env.REACT_APP_ENV || "dev",
            limit: 20
          }}
          onTicketClick={setSelectedTicket}
        />
        <TicketDetail
          ticket={selectedTicket}
          onClose={() => setSelectedTicket(null)}
        />
      </div>
    </>
  );
};

export default LiveTicketsPage;
